module.exports = __webpack_public_path__ + "img/Shape-dot.a3fe8680.svg";